// extracted by mini-css-extract-plugin
export default {"toggle":"List_toggle__-zwZA","removed":"List_removed__eGAhD"};